import { API_URL, MOKA_SERVICE_HOST } from '../constants';

export const V1_NEW_URL = `${API_URL}/v1/s3/new`;

export const UPLOAD_NEW_FILE_URL = `${MOKA_SERVICE_HOST}/upload/file`;

export const UPLOAD_NEW_IMAGE_URL = `${MOKA_SERVICE_HOST}/upload/image`;
